import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/confidentialite" element={<Privacy />} />
          </Routes>
          <Toaster position="bottom-center" />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
